module.exports = __webpack_public_path__ + "img/pw.c52b83d0.png";